import $ from "jquery";

const smoothScroll = () => {
    $('a[href^="#"]').on("click", function (event) {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store the hash (target ID)
        const target = this.hash;

        // Check if the target exists
        const $targetElement = $(target);
        if ($targetElement.length) {
            // Scroll to the target element with animation
            $("html, body").animate(
                {
                    scrollTop: $targetElement.offset().top,
                },
                800, // Animation duration in milliseconds
                function () {}
            );
        }
    });
};

export default smoothScroll;
